export default "/fires.c991e456-dee0ce.png";